export default __webpack_public_path__ + "static/eu-horizontal-ef4b0e1aec10c37ef0f281c08c8f706e.png";